import { connect } from 'react-redux';

import {
  mapStateToProps,
} from './props';

import AdminActionsView from './AdminActionsView';

export default connect(mapStateToProps)(AdminActionsView);
